import React from "react";
import { CommonNode, RichText } from "@foundation/rich-text-react-renderer";

import { footerOptions } from "~config/richtext";

type FooterProps = {
    footer: CommonNode;
};

export default function Footer({ footer }: FooterProps) {
    return <RichText story={footer} renderers={footerOptions} />;
}
